var map = {
	"./sort／pad／3D @2x.png": "c3dc",
	"./sort／pad／Action@2x.png": "7405",
	"./sort／pad／Adventure@2x.png": "fd79",
	"./sort／pad／Arcide@2x.png": "037d",
	"./sort／pad／Boy@2x.png": "30cf",
	"./sort／pad／Fighting@2x.png": "0aa2",
	"./sort／pad／Girl@2x.png": "b543",
	"./sort／pad／Hypercasual@2x.png": "b1d7",
	"./sort／pad／IO@2x.png": "6059",
	"./sort／pad／Puzzle@2x.png": "ed00",
	"./sort／pad／Racing@2x.png": "3f52",
	"./sort／pad／Shooting@2x.png": "6ef3",
	"./sort／pad／Sport@2x.png": "a041",
	"./sort／phone／3D @2x.png": "5c0f",
	"./sort／phone／Action@2x.png": "63b5",
	"./sort／phone／Adventure@2x.png": "26ef",
	"./sort／phone／Arcide@2x.png": "1ad5",
	"./sort／phone／Boy@2x.png": "e900",
	"./sort／phone／Fighting@2x.png": "5800",
	"./sort／phone／Girl@2x.png": "deb8",
	"./sort／phone／Hypercasual@2x.png": "87a6",
	"./sort／phone／IO@2x.png": "227c",
	"./sort／phone／Puzzle@2x.png": "0ce1",
	"./sort／phone／Racing@2x.png": "1726",
	"./sort／phone／Shooting@2x.png": "4fcb",
	"./sort／phone／Sport@2x.png": "9716",
	"./sort／web／3D @2x.png": "8c28",
	"./sort／web／Action@2x.png": "19a7",
	"./sort／web／Adventure@2x.png": "0e0e",
	"./sort／web／Arcade@2x.png": "07e7",
	"./sort／web／Boy@2x.png": "812c",
	"./sort／web／Fighting@2x.png": "85b0",
	"./sort／web／Girl@2x.png": "875f",
	"./sort／web／Hypercasual@2x.png": "2df9",
	"./sort／web／IO@2x.png": "8f55",
	"./sort／web／Puzzle@2x.png": "d07d",
	"./sort／web／Racing@2x.png": "5d43",
	"./sort／web／Shooting@2x.png": "812a",
	"./sort／web／Sport@2x.png": "9302"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710b";